/*
 * @Author: Dadamuga Mazino
 * @Date: 2018-01-11 14:59:22
 * @Last Modified by: Dadamuga Mazino
 * @Last Modified time: 2018-11-23 14:16:31
 */
import React, { Component } from "react";
import "./App.css";
import { BrowserRouter as Router, Route } from "react-router-dom";
import SynthCity from "./components/synthcity/SynthCity";
import TermsAndPrivacy from "./components/synthcity/TermsAndPrivacy";
import { Redirect, Switch } from "react-router";
import "./components/landing/LandingPage.css";

class App extends Component {
  render() {
    return (
      <div className="App">
        <Router>
          <div>
            <Switch>              
              <Route exact path="/" component={SynthCity} />
              <Route exact path="/synthcity" render={() => <Redirect to="/" />} />
              <Route exact path="/terms-privacy" component={TermsAndPrivacy} />
              
              {/* go home if it doesn't hit anything */}
              <Redirect to="/" />
            </Switch>
          </div>
        </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js